import cookie from 'cookie';
import { clone, onError } from '../../common/common';
import ChatApi from '../../design/api/chat-api';

// ------------------------------------
// Constants
// ------------------------------------
export const CHAT_TOGGLE = 'CHAT_TOGGLE';
export const CHAT_FULLSIZE_TOGGLE = 'CHAT_FULLSIZE_TOGGLE';
export const CHAT_SELECT_ROOM_TOGGLE = 'CHAT_SELECT_ROOM_TOGGLE';
export const UPDATE_UNREAD_COUNT = 'UPDATE_UNREAD_COUNT';
export const UPDATE_CHAT_INFO = 'UPDATE_CHAT_INFO';

// ------------------------------------
// Actions
// ------------------------------------

export const toggleChat = visibility => {
  // let hideChat = !visibility;
  // let hideChat = !(visibility === undefined
  //   ? cookie.parse(document.cookie).hideChat === 'true'
  //   : visibility);
  // document.cookie = `hideChat=${hideChat}`;
  return { type: CHAT_TOGGLE, payload: {} };
};

// ------------------------------------

export const toggleChatFullsize = () => {
  return { type: CHAT_FULLSIZE_TOGGLE };
};

export const toggleSelectChatRooms = () => {
  return { type: CHAT_SELECT_ROOM_TOGGLE };
};

export const loadUnreadCount = chatId => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      ChatApi.getUnreadCount(
        chatId,
        data => {
          dispatch({ type: UPDATE_UNREAD_COUNT, payload: { unreadCount: data.new_messages } });
          if (data.visible) {
            dispatch({ type: CHAT_TOGGLE, payload: { visibility: true } });
          }
        },
        onError,
      );

      resolve();
    });
  };
};

export const setUnreadCount = data => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_UNREAD_COUNT, payload: { unreadCount: data.new_messages } });
  };
};

export const updateChatInfo = data => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_CHAT_INFO, payload: { chat: data.chat } });
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processToggle = (state, action) => {
  const unreadCount = state.chats
    .map(c => c.new_messages_count)
    .reduce((prev, next) => prev + next);
  const newState = clone(state, { unreadCount: unreadCount });

  if (action.payload.visibility === undefined) {
    newState.visible = !newState.visible;
  } else {
    newState.visible = action.payload.visibility;
  }
  return newState;
};

const processUpdateChatInfo = (state, action) => {
  const { chats, currentUser } = state;
  let { chat: activeChat } = state;
  const { chat } = action.payload;
  if (
    chat.new_messages_count === 1 &&
    chat.last_message &&
    currentUser.id === chat.last_message.user.id
  ) {
    chat.new_messages_count = 0;
  }

  let newChats;
  const index = chats.findIndex(iChat => iChat.id === chat.id);
  if (index !== -1) {
    newChats = [...chats];
    const existingChat = { ...chats[index] };
    newChats[index] = chat;
    chat.active = existingChat.active;
    if (activeChat.id === chat.id) {
      activeChat = chat;
    }
    chat.new_messages_count =
      (existingChat.new_messages_count || 0) + (chat.new_messages_count || 0);
  } else {
    newChats = [chat, ...chats];
  }
  const unreadCount = newChats
    .map(chatI => chatI.new_messages_count)
    .reduce((prev, next) => prev + next);
  return { ...state, chats: newChats, unreadCount, chat: activeChat };
};

const processFullsizeToggle = state => clone(state, { fullsize: !state.fullsize });

const processChatSelectRoomToggle = state =>
  clone(state, { chatSelectRoomOpen: !state.chatSelectRoomOpen });

const processUpdateUnread = (state, action) => {
  return clone(state, { unreadCount: action.payload.unreadCount });
};

export const CHAT_BUTTON_ACTION_HANDLERS = {
  [CHAT_TOGGLE]: processToggle,
  [CHAT_FULLSIZE_TOGGLE]: processFullsizeToggle,
  [UPDATE_UNREAD_COUNT]: processUpdateUnread,
  [CHAT_SELECT_ROOM_TOGGLE]: processChatSelectRoomToggle,
  [UPDATE_CHAT_INFO]: processUpdateChatInfo,
};



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/modules/chat-button.js